import { render, staticRenderFns } from "./ShareBlock.vue?vue&type=template&id=0e7c2cee&"
import script from "./ShareBlock.vue?vue&type=script&lang=js&"
export * from "./ShareBlock.vue?vue&type=script&lang=js&"
import style0 from "./ShareBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports